import { getToken,axiosInstance } from "../../utils/Api";

export const deleteGame = async (quiz_id) =>{ 
    try {
        const response = await axiosInstance.delete(`/admin/games/gameDelete`,{
          data:{id:quiz_id},
            headers: {
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response?.data;
      } catch (error) {
        throw error;
      } 
}  
 
export const updateGame = async (formdata) =>{  
    try {
        const response = await axiosInstance.post("/admin/games/updateGame",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      }  
}  
export const gameCreate = async (formdata) =>{  
    try {
        const response = await axiosInstance.post("/admin/games/createGame",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      }  
}  

export const getGameData = async (id) =>{ 
  try { 
      const response = await axiosInstance.get(`admin/games/getGameData?game_id=${id}`,{
        headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data; 
    } catch (error) {
      throw error;
  } 
}
export const getAssets = async () =>{ 
  try { 
      const response = await axiosInstance.get(`admin/games/fetchAssets`,{
        headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data; 
    } catch (error) {
      throw error;
  } 
}
export const getAssetDataByID = async (id) =>{ 
  try { 
      const response = await axiosInstance.get(`admin/games/fetchAssetById?id=${id}`,{
        headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data; 
    } catch (error) {
      throw error;
  } 
}
export const createGameQuestion = async (formdata) =>{ 
  try {
      const response = await axiosInstance.post(`admin/games/createGameQuestion`,formdata,{
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response?.data;
    } catch (error) {
      throw error;
    } 
} 

export const updateQuestion = async (formdata) =>{  
  try {
      const response = await axiosInstance.post("/admin/games/updateQuestion",formdata,{
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    }  
}  

export const deleteQuestion = async (qus_id) =>{ 
  try {
      const response = await axiosInstance.delete(`/admin/games/questionDelete`,{
        data:{id:qus_id},
          headers: {
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response?.data;
    } catch (error) {
      throw error;
    } 
}  